import { Gallery, FileType, GlobalFunctions, ValueFormat } from 'globales-projekt-angular';
import { Lightbox } from 'ngx-lightbox';
import { Gebaeude } from '../data/ws/dbKlassen/gebaeude.model';
import { ErgebnisGebaeude } from '../data/ws/ergebnis/gebaeude/ergebnis-gebaeude.model';

export class Functions {
  static openGallery(lightbox: Lightbox, gebaeude: Gebaeude): void {
    let gallery: Gallery[] = [];

    gebaeude.dateiList
      .filter((datei) => datei.mimetype !== FileType.PDF)
      .forEach((entry) => {
        gallery.push(new Gallery(entry.base64Image, gebaeude.bezeichnung));
      });

    GlobalFunctions.openGallery(lightbox, gallery);
  }

  static getChartLabels(ergebnisGebaeudeList: ErgebnisGebaeude[], istGebaeude: boolean): (string | string[])[] {
    let valueFormat: ValueFormat = new ValueFormat();

    let chartLabels: (string | string[])[] = [];
 //   let durchschnitt: boolean = true;
    ergebnisGebaeudeList.forEach((entry) => {
   /*   if (ergebnisGebaeudeList.length > 1 && durchschnitt) {
        chartLabels.push(['Durchschnitt', 'ausgewählter Modelle']);
        durchschnitt = false;
      } else {*/
        if (istGebaeude)
        {
          entry.gebaeude.flaechenVolumen.some((entry2) => { 
          
            if (entry2.istKostenrelevant) {
              chartLabels.push([
                entry.gebaeude.bezeichnung,
                '\u00A0' + valueFormat.getStringDecimal(entry2.wert, 0) + '\u00A0' + entry2.dimension
              ]);
               return true; // Schleife beenden
            }
            return false; // Weiter mit der Schleife
          });
        }
        else{
          entry.gebaeude.tierplaetze.forEach((entry2) => {
            if (entry2.istKostenrelevant) {
              chartLabels.push([
                entry.gebaeude.bezeichnung,
                '\u00A0' + valueFormat.getStringDecimal(entry2.wert, 0) + '\u00A0' + entry2.dimension
              ]);

              return true;
            } 

            return false
          });

       }


 //     }
    });

    return chartLabels;
  }
}
